/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  min-height: 1.2857142857rem;
  font-size: 1rem;
  line-height: 1.2857142857rem;
  text-align: left;
  display: block;
}

.message {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}

/*
 * IMPORTANT
 *
 * keep the sequence of [success], [warning], [error]
 * => error is pioritized over warning and warning is prioritized over success
 */
:host([success]) .message {
  color: #63b017;
  color: var(--davinci-color-success, #63b017);
}

:host([warning]) .message {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}

:host([error]) .message {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}

:host([hidden]) {
  display: none;
}`;
export { style };
